<div
  class="flex max-w-[900px] items-center text-neutral-900"
  [ngClass]="rootClass()"
>
  @switch (type()) {
    @case (types.Success) {
      <img
        priority="true"
        alt="Success Icon"
        width="40"
        height="40"
        [ngSrc]="'/assets/icons/ic_diamond.svg'"
      />
    }
    @case (types.Error) {
      <img
        priority="true"
        alt="Warning Icon"
        width="40"
        height="40"
        [ngSrc]="'/assets/icons/ic_warning_fire.svg'"
      />
    }
    @default {
      <mat-icon
        [ngClass]="{
          'min-h-10 min-w-9': size() === 'big',
          'text-error-500': type() === types.Error,
          'text-warning-500': type() === types.Warning,
          'text-success-500': type() === types.Success,
          'text-primary-500': type() === types.Info,
          'mt-1 -mr-1 text-sm': size() === 'small',
        }"
      >
        warning_amber
      </mat-icon>
    }
  }
  <span class="flex flex-col gap-2">
    {{ text() }}
    @if (size() === "big" && subText()) {
      <span
        class="font-thin"
        [ngClass]="textSize() || 'text-sm'"
        >{{ subText() }}</span
      >
    }
  </span>
</div>
